(function () {
  'use strict';

  /* Lightweight replacements for the small Empire-theme behaviours still
     visible on the native homepage. This intentionally avoids loading the
     full Empire runtime on the homepage. */

  function initBackToTop() {
    var wrap = document.querySelector('[data-back-to-top]');
    if (!wrap) return;
    var button = wrap.querySelector('button');
    var ticking = false;

    function update() {
      ticking = false;
      var max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      var visible = (window.scrollY / max) >= 0.30;
      wrap.setAttribute('data-animation-state', visible ? 'visible' : 'hidden');
    }

    if (button) {
      button.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });

    update();
  }

  function closeDisclosure(disclosure) {
    if (!disclosure) return;
    var toggle = disclosure.querySelector('[data-disclosure-toggle]');
    var list = disclosure.querySelector('[data-disclosure-list]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (list) list.classList.remove('disclosure-list--visible');
  }

  function initDisclosures() {
    document.querySelectorAll('.disclosure').forEach(function (disclosure) {
      var toggle = disclosure.querySelector('[data-disclosure-toggle]');
      var list = disclosure.querySelector('[data-disclosure-list]');
      var input = disclosure.parentElement && disclosure.parentElement.querySelector('[data-disclosure-input]');
      var form = disclosure.closest('form');
      if (!toggle || !list) return;

      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        var open = !list.classList.contains('disclosure-list--visible');
        document.querySelectorAll('.disclosure').forEach(function (other) {
          if (other !== disclosure) closeDisclosure(other);
        });
        list.classList.toggle('disclosure-list--visible', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      list.addEventListener('click', function (event) {
        var option = event.target.closest('[data-disclosure-option]');
        if (!option) return;
        event.preventDefault();
        if (input) input.value = option.getAttribute('data-value') || '';
        closeDisclosure(disclosure);
        if (form) form.submit();
      });
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('.disclosure')) return;
      document.querySelectorAll('.disclosure').forEach(closeDisclosure);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.disclosure').forEach(closeDisclosure);
    });
  }

  function init() {
    initBackToTop();
    initDisclosures();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
